// extracted by mini-css-extract-plugin
export default {"date_container":"DateContainer_date_container__ieeh1"};